export function computeValueAvg(results: any, key: string, round: number) {
    if (!results[round]) return 0;
    const timestamps = results[round]["timestamps"];
    let average = 0;
    timestamps.forEach((element: any) => {
        const values = element["values"];
        average += values[key];
    });
    average = (average / timestamps.length) || 0;

    return average;
}

/**
 * Computes average for array of cumulative values.
 * @param results 
 * @param key 
 * @param round 
 * @returns 
 */
export function computeCumulAvg(results: any, key: string, round: number) {
    if (!results[round]) return 0;
    const timestamps = results[round]["timestamps"];
    let average = 0;
    let prevValue = 0;
    timestamps.forEach((element: any) => {
        const values = element["values"];
        average += values[key] - prevValue;
        prevValue = values[key];
    });
    average = (average / timestamps.length) || 0;

    return average;
}

export function computeValueTotal(results: any, key: string, round: number) {
    if (!results[round]) return 0;
    const timestamps = results[round]["timestamps"];
    let total = 0;
    timestamps.forEach((element: any) => {
        const values = element["values"];
        total += values[key];
    });

    return total;
}

export function computeFinalScore(finalScores: number[]) {
    let res = 0;
    finalScores.forEach((roundScore) => {
        res += roundScore;
    });
    res = (res / finalScores.length) || 0;
    return Math.round(res);
}

export function computeFinalAvg(results: any, key: string, maxRound: number) {
    let finalAvg = 0;
    for (let i = 0; i < maxRound; ++i) {
        finalAvg += computeValueAvg(results, key, i);
    }
    finalAvg /= maxRound;
    return finalAvg;
}

export function computeFinalCumulAvg(results: any, key: string, maxRound: number) {
    let finalAvg = 0;
    for (let i = 0; i < maxRound; ++i) {
        finalAvg += computeCumulAvg(results, key, i);
    }
    finalAvg /= maxRound;
    return finalAvg;
}

export function computeFinalTotal(results: any, key: string, maxRound: number) {
    let total = 0;
    for (let i = 0; i < maxRound; ++i) {
        total += computeValueTotal(results, key, i);
    }
    return total;
}